import React from 'react'

function CollectorsRowHeading({ Collector, WorksCollected, WorksOwned, AvgPurchasePrice, TotalPurchases, BiggestPurchase }) {
    return (
        <tr className="tableSingleRow">
            <th>{ Collector }</th>
            <th>{ WorksCollected }</th>
            <th>{ WorksOwned }</th>
            <th>{ AvgPurchasePrice }</th>
            <th>{ TotalPurchases }</th>
            <th>{ BiggestPurchase }</th>
        </tr>
    )
}

export default CollectorsRowHeading
